import { useEffect } from 'react';

const useOutsideAlerter = (ref, visible, setPopUp) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        visible &&
        ((event.target.className.length > 0 && event?.target?.className?.includes('showpopup')) ||
          event?.target?.offsetParent?.className?.includes('showpopup') ||
          event?.target?.localName?.includes('input') ||
          event?.target?.localName?.includes('path') ||
          event?.target?.localName?.includes('svg'))
      ) {
        if (
          ref?.current &&
          (Object.values(event?.target?.classList).some((item) =>
            item.includes('showpopupInner'),
          ) ||
            event?.target?.offsetParent?.className?.includes('showpopupInner') ||
            event?.target?.nearestViewportElement?.className?.baseVal?.includes('showpopupInner'))
            ? ref?.current?.contains(event.target)
            : !ref?.current?.contains(event.target)
        ) {
          setPopUp(true);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, setPopUp, visible]);
};

export default useOutsideAlerter;
